/* STEMZ hover audio preview: own code. One shared <audio>, so only one preview plays at a time.
   Playback is click-driven only: moving the mouse / leaving the card never pauses it.
   It stops on: pause click, another card's play, the 60 s cap, Escape, or leaving the page. */
(function(){
  if (window.__stzAP) return; window.__stzAP = true;
  var MAX_S = 60;                     // hard cap per preview (Will 2026-10-30: 60 s previews on Logic)
  var audio = new Audio(); audio.preload = 'none';
  var cur = null;                     // active button (playing, or paused mid-preview)

  function setState(btn, playing){
    if (!btn) return;
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    btn.setAttribute('aria-label', btn.getAttribute(playing ? 'data-label-pause' : 'data-label-play'));
    if (!playing) btn.classList.remove('is-loading');
  }
  function reset(btn){ if (!btn) return; setState(btn, false); btn.classList.remove('is-active'); btn.style.setProperty('--stz-ap-p', 0); }
  function stop(){ if (!cur) return; audio.pause(); try { audio.currentTime = 0; } catch(e){} reset(cur); cur = null; }
  function pause(){ if (!cur) return; audio.pause(); setState(cur, false); }   // keeps cur + progress, button stays visible
  function play(btn){
    if (cur && cur !== btn) stop();
    cur = btn; btn.classList.add('is-active');
    document.dispatchEvent(new CustomEvent('stz-ap:play'));
    var src = btn.getAttribute('data-src');
    if (audio.getAttribute('src') !== src) { audio.src = src; }   // lazy: nothing downloads before the first click
    if (audio.currentTime >= MAX_S) audio.currentTime = 0;
    btn.classList.add('is-loading'); setState(btn, true);
    var p = audio.play();
    if (p && p.catch) p.catch(function(){ if (cur === btn) { reset(btn); cur = null; } });
  }
  audio.addEventListener('playing', function(){ if (cur) cur.classList.remove('is-loading'); });
  audio.addEventListener('waiting', function(){ if (cur) cur.classList.add('is-loading'); });
  audio.addEventListener('timeupdate', function(){
    if (!cur) return;
    var d = Math.min(audio.duration || MAX_S, MAX_S);
    cur.style.setProperty('--stz-ap-p', Math.min(audio.currentTime / d, 1));
    if (audio.currentTime >= MAX_S) stop();
  });
  audio.addEventListener('ended', stop);
  audio.addEventListener('error', stop);

  // Position each overlay exactly over the card's cover figure (absolute => zero layout shift).
  function place(ov){
    var card = ov.parentElement, fig = card && card.querySelector('figure');
    if (!fig) return;
    ov.style.top = fig.offsetTop + 'px'; ov.style.left = fig.offsetLeft + 'px';
    ov.style.width = fig.offsetWidth + 'px'; ov.style.height = fig.offsetHeight + 'px';
    ov.hidden = false;
  }
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function(es){ es.forEach(function(e){ var ov = e.target.querySelector(':scope > [data-stz-ap]'); if (ov) place(ov); }); }) : null;
  function init(root){
    (root || document).querySelectorAll('[data-stz-ap]:not([data-stz-ready])').forEach(function(ov){
      ov.setAttribute('data-stz-ready', '');
      var card = ov.parentElement; card.classList.add('stz-ap-host');
      place(ov); if (ro) ro.observe(card);
    });
    // Card re-rendered (filters, sliders cloning)? Keep playing and move the active state to the new button.
    if (cur && !cur.isConnected) {
      var src = cur.getAttribute('data-src'), nb = null;
      document.querySelectorAll('.stz-ap__btn').forEach(function(b){ if (!nb && b.getAttribute('data-src') === src) nb = b; });
      if (nb) { nb.style.setProperty('--stz-ap-p', cur.style.getPropertyValue('--stz-ap-p')); cur = nb; nb.classList.add('is-active'); setState(nb, !audio.paused); }
    }
  }
  // Delegated click: works for cards added later (sliders, infinite scroll, AJAX filters)
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.stz-ap__btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();     // never trigger the card link or swiper drag
    if (cur === btn && !audio.paused) pause(); else play(btn);
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') stop(); });
  document.addEventListener('ltp:play', function(){ stop(); });   // product-page player started
  window.addEventListener('pagehide', stop);
  if (!ro) window.addEventListener('resize', function(){ document.querySelectorAll('[data-stz-ap]').forEach(place); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  var q = 0; new MutationObserver(function(){ if (q) return; q = requestAnimationFrame(function(){ q = 0; init(); }); }).observe(document.documentElement, {childList:true, subtree:true});
})();
